import Model  from '@/util/models';

export default class Calon extends Model { 
    backend = '/master/calon/'; 
   
    index(params = {}){
      return this.api.get('/master/siswa/index', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }
    
    indexRekap(params = {}){
      return this.api.get(this.backend + 'index-rekap', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
    
    indexQuran(params = {}){
      return this.api.get('/master/siswa/index-quran', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }
    
    saveQuran(body){
      return this.api.post(this.backend + 'save-quran', body);
    }
    
    indexKelengkapan(params = {}){
      return this.api.get('/master/siswa/index-kelengkapan', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }
    
    saveKelengkapan(body){
      return this.api.post(this.backend + 'save-kelengkapan', body);
    }
    
    kelengkapans(){
      return this.api.get(this.backend + 'kelengkapans').then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }

    gedungs(params = {}){
      return this.api.get('/master/siswa/gedungs', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }

    indexRapor(params = {}){
      return this.api.get('/master/siswa/index-rapor', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }
    
    saveRapor(body){
      return this.api.post(this.backend + 'save-rapor', body);
    }
    

    indexUjian(params = {}){
      return this.api.get('/master/siswa/index-ujian', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }

    viewUjian(params = {}){
      return this.api.get('/master/siswa/view-ujian', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }
    
    saveUjian(body){
      return this.api.post(this.backend + 'save-ujian', body);
    }

    ujianRefresh(body, params){
      return this.api.post(this.backend + 'ujian-refresh', body, params);
    }

    ujianResetNilai(body, params){
      return this.api.post(this.backend + 'ujian-reset-nilai', body, params);
    }

    ujianResetQuetionnaire(body, params){
      return this.api.post(this.backend + 'ujian-reset-quetionnaire', body, params);
    }
    
    settings(params={}){
      return this.api.get(this.backend + 'settings', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
    
    cekRuangan(params){
      return this.api.get(this.backend + 'cek-ruangan', params);
    }
    
    indexKelulusan(params = {}){
      return this.api.get(this.backend + 'index-kelulusan', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
    
    saveKelulusan(body){
      return this.api.post(this.backend + 'save-kelulusan', body);
    }
    
    indexSearch(params = {}){
      return this.api.get(this.backend + 'index-search', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
    
    onePayment(params = {}){
      return this.api.get(this.backend + 'findbyid-payment', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }        
    
    indexPayment(params = {}){
      return this.api.get('/master/siswa/index-payment', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }
    
    savePayment(body){
      return this.api.post(this.backend + 'save-payment', body);
    }
    
    confirmPayment(body){
      return this.api.post(this.backend + 'confirm-payment', body);
    }
    
    unconfirmPayment(body){
      return this.api.post(this.backend + 'unconfirm-payment', body);
    }
    
    removePayment(body){
      return this.api.post(this.backend + 'delete-payment', body);
    }
    
    paymentTypes(params = {}){
      return this.api.get(this.backend + 'payment-types', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
    
    paymentStatus(){
      return this.api.get(this.backend + 'payment-status').then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
    
    completeAdministrasi(formdata){
        return this.api.post(this.backend + 'update-complete', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }        
    
    userSignup(params = {}){
      return this.api.get( '/master/siswa/user-signup', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }
    
    tingkats(params = {}){
      return this.api.get(this.backend + 'tingkats', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
    
    status(){
      return this.api.get(this.backend + 'status').then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }        
    
    create(formdata){
        return this.api.post(this.backend + 'create', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
    
    update(formdata){
        console.log(formdata);
        return this.api.post(this.backend + 'update', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
    
    setavatar(formdata){
        return this.api.post(this.backend + 'setavatar', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
    
    getavatar(params){
        return this.api.get(this.backend + 'getavatar', params); 
    }        
    
    provinsis(params){
        return this.api.get(this.backend + 'provinsis', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }
    
    kotas(params){
        return this.api.get(this.backend + 'kotas', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }
    
    kecamatans(params){
        return this.api.get(this.backend + 'kecamatans', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }
    
    kelurahans(params){
        return this.api.get(this.backend + 'kelurahans', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }
}

